






import {
  computed,
  defineComponent,
  PropType,
  useStore,
} from '@nuxtjs/composition-api'
import NavigationSection from '@/components/Navigation/NavigationSection.vue'
import { NormalizedSection } from '@/contracts/Navigation'

export default defineComponent({
  components: { NavigationSection },
  props: {
    section: {
      type: Object as PropType<NormalizedSection>,
      default: null,
    },
  },
  setup(props) {
    const store = useStore()
    const navigation = computed(
      () => props.section || store.getters['settings/navigation']
    )
    return {
      navigation,
    }
  },
})
